// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1h-q";
export var animationRelative = "_1h-p";
export var backdropBlur = "_1h-0";
export var detailLabelCell = "_1h-12";
export var detailTable = "_1h-11";
export var detailValueCell = "_1h-13";
export var docIconBox = "_1h-1d";
export var docIconBoxMd = "_1h-1f";
export var docIconBoxSm = "_1h-1e";
export var docTypeRow = "_1h-16";
export var docTypeRowInner = "_1h-17";
export var dropdownMatchDatePicker = "_1h-3";
export var evidenceCardContent = "_1h-1c";
export var fileUploadSpin = "_1h-j";
export var gorgiasOpenButton = "_1h-15 _1h-d";
export var gorgiasTicketCard = "_1h-14";
export var heroModalFooterButton = "_1h-18";
export var hiddenContainer = "_1h-o";
export var iconPrimary = "_1h-1g";
export var iconSecondary = "_1h-1h";
export var iconTertiary = "_1h-1i";
export var integrationCard = "_1h-1";
export var integrationLogoBox = "_1h-2";
export var mainColumnSticky = "_1h-1b";
export var maxWidthContainer = "_1h-19";
export var modalContentBody = "_1h-a";
export var modalHeaderImage = "_1h-5";
export var modalImageLabel = "_1h-7";
export var modalImageOverlay = "_1h-6";
export var modalImageSubtitle = "_1h-9";
export var modalImageTitle = "_1h-8";
export var modalImageWrapper = "_1h-4";
export var modalStickyFooter = "_1h-b";
export var removeButton = "_1h-e";
export var sidebarColumn = "_1h-1a";
export var spinner = "_1h-i";
export var timelineLine = "_1h-y";
export var timelineLineBlack = "_1h-10 _1h-y";
export var timelineLineGray = "_1h-z _1h-y";
export var timelineLineHeight = "_1h-x";
export var tlDotActivate = "_1h-u";
export var tlDotActivateAnim = "_1h-t";
export var tlDotHide = "_1h-s";
export var tlDotHideAnim = "_1h-r";
export var tlLineActivate = "_1h-w";
export var tlLineActivateAnim = "_1h-v";
export var uploadHint = "_1h-n";
export var uploadIconBox = "_1h-k";
export var uploadLabel = "_1h-m";
export var uploadText = "_1h-l";
export var uploadZone = "_1h-f";
export var uploadZoneCursorDefault = "_1h-h";
export var uploadZoneCursorPointer = "_1h-g";
export var uploadedFileRow = "_1h-c";
export var viewButton = "_1h-d";